


type Props = {
    fillColor?: string,
    onClick?: (e: React.MouseEvent<SVGElement>) => void,
} & typeof defaultProps;

const defaultProps = {
    fillColor: "#001760",
    onClick: () => { },
};
const CloseFilledIcon = function CloseFilledIcon(props: Props) {
    const { fillColor, onClick } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" onClick={onClick}>
            <ellipse cx="5.88235" cy="6.00001" rx="5.88235" ry="5.67742" fill={fillColor} />
            <path d="M7.82353 3.056L5.88246 4.92946L3.94138 3.056L2.83219 4.12655L4.77327 6L2.83219 7.87345L3.94138 8.944L5.88246 7.07054L7.82353 8.944L8.93272 7.87345L6.99164 6L8.93272 4.12655L7.82353 3.056Z" fill="white" />
        </svg>
    );
};
CloseFilledIcon.defaultProps = defaultProps;
export default CloseFilledIcon;